/**
 * Back in Stock via Klaviyo (public key, client-side).
 * Primary: Klaviyo client API (CORS-enabled, gives a real 202/error response).
 * Fallback: onsite endpoint via no-cors (fire-and-forget) if the client API is
 * blocked. Logged-in customers register in one click with their account email;
 * guests get a small inline email field. Confirmation toast on success.
 */
(function () {
  var KEY = window.hskdKlaviyoKey;
  var LOGGED_EMAIL = window.hskdCustomerEmail;
  if (!KEY) return;

  var CLIENT_URL = 'https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=' + encodeURIComponent(KEY);
  var ONSITE_URL = 'https://a.klaviyo.com/onsite/components/back-in-stock/subscribe';
  var DONE_MSG = "You're on the list — we'll email you when it's back in stock.";
  var ERR_MSG = 'Sorry, something went wrong — please try again.';

  function toast(msg) {
    var el = document.createElement('div');
    el.className = 'hskd-toast';
    el.setAttribute('role', 'status');
    el.textContent = msg;
    document.body.appendChild(el);
    requestAnimationFrame(function () { el.classList.add('is-visible'); });
    setTimeout(function () {
      el.classList.remove('is-visible');
      setTimeout(function () { if (el.parentNode) el.parentNode.removeChild(el); }, 300);
    }, 4000);
  }

  function validEmail(e) { return /^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(e); }

  // Preferred: Klaviyo client API — returns { ok, status, data }.
  function subscribeClient(email, variantId) {
    return fetch(CLIENT_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', revision: '2024-06-15' },
      body: JSON.stringify({
        data: {
          type: 'back-in-stock-subscription',
          attributes: {
            profile: { data: { type: 'profile', attributes: { email: email } } },
            channels: ['EMAIL']
          },
          relationships: {
            variant: { data: { type: 'catalog-variant', id: '$shopify:::$default:::' + variantId } }
          }
        }
      })
    }).then(function (res) {
      return res.text().then(function (text) {
        var data;
        try { data = JSON.parse(text); } catch (e) { data = text; }
        return { ok: res.status === 202 || res.ok, status: res.status, data: data };
      });
    });
  }

  // Fallback: onsite endpoint, fire-and-forget (opaque response, assume delivered).
  function subscribeOnsite(email, variantId) {
    var body = new URLSearchParams();
    body.set('a', KEY);
    body.set('email', email);
    body.set('variant', variantId);
    body.set('platform', 'shopify');
    return fetch(ONSITE_URL, {
      method: 'POST',
      mode: 'no-cors',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: body.toString()
    }).then(function () { return { ok: true, via: 'onsite' }; });
  }

  function subscribe(email, variantId) {
    return subscribeClient(email, variantId).catch(function (err) {
      console.warn('[BIS] client API blocked, falling back to onsite', err);
      return subscribeOnsite(email, variantId);
    });
  }


  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.js-hskd-notify');
    if (!btn || btn.dataset.done === '1') return;
    e.preventDefault();

    var variantId = btn.getAttribute('data-variant-id');
    var wrap = btn.closest('.hskd-atc__soldout') || btn.parentNode;

    // Logged-in: one click, no form.
    if (LOGGED_EMAIL) {
      btn.disabled = true;
      btn.textContent = 'Registering…';
      subscribe(LOGGED_EMAIL, variantId).then(function (r) {
        if (r.ok) {
          btn.dataset.done = '1';
          btn.textContent = 'Registered ✓';
          toast(DONE_MSG);
        } else {
          console.error('[BIS]', r.status, r.data);
          btn.disabled = false;
          btn.textContent = 'Notify when available';
          toast(ERR_MSG);
        }
      });
      return;
    }

    // Guest: reveal a small inline email field (once).
    if (wrap.querySelector('.hskd-notify-inline')) return;
    var form = document.createElement('form');
    form.className = 'hskd-notify-inline';
    form.innerHTML =
      '<input type="email" required placeholder="Email address" class="hskd-notify-email" autocomplete="email">' +
      '<button type="submit" class="hskd-add hskd-add--notify">Notify me</button>';
    btn.style.display = 'none';
    wrap.appendChild(form);
    var input = form.querySelector('input');
    input.focus();

    form.addEventListener('submit', function (ev) {
      ev.preventDefault();
      var email = input.value.trim();
      if (!validEmail(email)) { input.focus(); return; }
      var sub = form.querySelector('button');
      sub.disabled = true;
      sub.textContent = 'Registering…';
      subscribe(email, variantId).then(function (r) {
        if (r.ok) {
          btn.dataset.done = '1';
          form.innerHTML = '<span class="hskd-notify-ok">Registered ✓</span>';
          toast(DONE_MSG);
        } else {
          console.error('[BIS]', r.status, r.data);
          sub.disabled = false;
          sub.textContent = 'Notify me';
          toast(ERR_MSG);
        }
      });
    });
  });
})();
